var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalanceBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.88 511.88",
    height: 512,
    viewBox: "0 0 511.88 511.88",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m167.297 252.506c-11.553 16.919-18.319 37.355-18.319 59.344 0 58.173 47.327 105.5 105.5 105.5s105.5-47.327 105.5-105.5c0-36.833-18.978-69.313-47.665-88.189z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.953 143.699h509.974v60h-509.974z",
    transform: "matrix(.981 -.195 .195 .981 -28.969 53.269)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceBall);
export default __webpack_public_path__ + "static/media/balance-ball.d711a5ea4d087c9c8508aee1ba7ea9b7.svg";
export { ForwardRef as ReactComponent };